import WebsiteModal from "modal/WebsiteModal";
import VideoHelper from "video/VideoHelper";

export default class VideoModal extends WebsiteModal {
    constructor($elem) {
        super();

        this.$element = $elem;
        this.url = this.$element.attr('href');
        this.videoPath = this.$element.data('video-url');

        this.videoPlayer = null;
    }

    buildModal() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--video js-modal", 'data-modal': "video"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "close-btn js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('div', {className: "modal__box"}, [
                        eotwJSXFactory('div', {className: "responsive-video"}, [
                            eotwJSXFactory('div', {className: "js-video-container"})
                        ])
                    ])
                ])
            ])
        );
    }

    buildElement() {
        this.buildModal();
    }

    show() {
        super.show();

        if (this.videoPlayer === null && !this.videoPath) {
            this.loadVideo();
        } else {
            this.$modal.find('.js-video-container').append(eotwJSXFactory('video', {loop: true, controls: true, autoPlay: true, playsInline: true, muted: true, src: this.videoPath}))
        }
    }

    loadVideo() {
        let information = this.getVideoInformationFromUrl();

        if (information === null) return;
        this.videoPlayer = VideoHelper.process(information.provider, information.videoId, this.$modal.find('.js-video-container'), {});
        this.videoPlayer.on('loaded', () => {
            this.videoPlayer.play();
        });
    }

    getVideoInformationFromUrl() {
        let YoutubeTest = new RegExp(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_YOUTUBE].url);
        if (YoutubeTest.test(this.url)) {
            return {
                "provider": VideoHelper.PROVIDER_YOUTUBE,
                "videoId": this.url.match(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_YOUTUBE].url)[1]
            }
        }
        let VimeoTest = new RegExp(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_VIMEO].url);
        if (VimeoTest.test(this.url)) {
            return {
                "provider": VideoHelper.PROVIDER_VIMEO,
                "videoId": this.url.match(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_VIMEO].url)[1]
            }
        }

        return null;
    }

    destroy() {
        if (this.videoPlayer !== null) {
            this.videoPlayer.destroy();
        }
        return super.destroy();
    }
}
